module.exports = __webpack_public_path__ + "static/media/SPOOKYSWAP-FTM-BOO.987d4fc2.png";